import { render, staticRenderFns } from "./SubHierarchy.vue?vue&type=template&id=046ec739&"
import script from "./SubHierarchy.vue?vue&type=script&lang=ts&"
export * from "./SubHierarchy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports